import {
  listOrders as publicListOrders,
  getOrder as publicGetOrder,
  updateOrder as publicUpdateOrder,
  bulkUpdateOrders as publicBulkUpdateOrders,
  confirmOrder as publicConfirmOrder,
  getSummary as publicGetSummary,
  captureAuthorizedPayment as publicCaptureAuthorizedPayment,
  voidAuthorizedPayment as publicVoidAuthorizedPayment,
  getCheckoutOptions as publicGetCheckoutOptions,
  listAvailableTickets as publicListAvailableTickets,
  queryAvailableTickets as publicQueryAvailableTickets,
  createReservation as publicCreateReservation,
  cancelReservation as publicCancelReservation,
  getInvoice as publicGetInvoice,
  checkout as publicCheckout,
  updateCheckout as publicUpdateCheckout,
  posCheckout as publicPosCheckout,
} from './events-v1-order-orders.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onOrderDeleted as publicOnOrderDeleted } from './events-v1-order-orders.public.js';
import { onOrderUpdated as publicOnOrderUpdated } from './events-v1-order-orders.public.js';
import { onOrderConfirmed as publicOnOrderConfirmed } from './events-v1-order-orders.public.js';
import { onOrderInitiated as publicOnOrderInitiated } from './events-v1-order-orders.public.js';
import { onOrderReservationCreated as publicOnOrderReservationCreated } from './events-v1-order-orders.public.js';
import { onOrderReservationUpdated as publicOnOrderReservationUpdated } from './events-v1-order-orders.public.js';

export const listOrders: MaybeContext<
  BuildRESTFunction<typeof publicListOrders> & typeof publicListOrders
> = /*#__PURE__*/ createRESTModule(publicListOrders);
export const getOrder: MaybeContext<
  BuildRESTFunction<typeof publicGetOrder> & typeof publicGetOrder
> = /*#__PURE__*/ createRESTModule(publicGetOrder);
export const updateOrder: MaybeContext<
  BuildRESTFunction<typeof publicUpdateOrder> & typeof publicUpdateOrder
> = /*#__PURE__*/ createRESTModule(publicUpdateOrder);
export const bulkUpdateOrders: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateOrders> &
    typeof publicBulkUpdateOrders
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateOrders);
export const confirmOrder: MaybeContext<
  BuildRESTFunction<typeof publicConfirmOrder> & typeof publicConfirmOrder
> = /*#__PURE__*/ createRESTModule(publicConfirmOrder);
export const getSummary: MaybeContext<
  BuildRESTFunction<typeof publicGetSummary> & typeof publicGetSummary
> = /*#__PURE__*/ createRESTModule(publicGetSummary);
export const captureAuthorizedPayment: MaybeContext<
  BuildRESTFunction<typeof publicCaptureAuthorizedPayment> &
    typeof publicCaptureAuthorizedPayment
> = /*#__PURE__*/ createRESTModule(publicCaptureAuthorizedPayment);
export const voidAuthorizedPayment: MaybeContext<
  BuildRESTFunction<typeof publicVoidAuthorizedPayment> &
    typeof publicVoidAuthorizedPayment
> = /*#__PURE__*/ createRESTModule(publicVoidAuthorizedPayment);
export const getCheckoutOptions: MaybeContext<
  BuildRESTFunction<typeof publicGetCheckoutOptions> &
    typeof publicGetCheckoutOptions
> = /*#__PURE__*/ createRESTModule(publicGetCheckoutOptions);
export const listAvailableTickets: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableTickets> &
    typeof publicListAvailableTickets
> = /*#__PURE__*/ createRESTModule(publicListAvailableTickets);
export const queryAvailableTickets: MaybeContext<
  BuildRESTFunction<typeof publicQueryAvailableTickets> &
    typeof publicQueryAvailableTickets
> = /*#__PURE__*/ createRESTModule(publicQueryAvailableTickets);
export const createReservation: MaybeContext<
  BuildRESTFunction<typeof publicCreateReservation> &
    typeof publicCreateReservation
> = /*#__PURE__*/ createRESTModule(publicCreateReservation);
export const cancelReservation: MaybeContext<
  BuildRESTFunction<typeof publicCancelReservation> &
    typeof publicCancelReservation
> = /*#__PURE__*/ createRESTModule(publicCancelReservation);
export const getInvoice: MaybeContext<
  BuildRESTFunction<typeof publicGetInvoice> & typeof publicGetInvoice
> = /*#__PURE__*/ createRESTModule(publicGetInvoice);
export const checkout: MaybeContext<
  BuildRESTFunction<typeof publicCheckout> & typeof publicCheckout
> = /*#__PURE__*/ createRESTModule(publicCheckout);
export const updateCheckout: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCheckout> & typeof publicUpdateCheckout
> = /*#__PURE__*/ createRESTModule(publicUpdateCheckout);
export const posCheckout: MaybeContext<
  BuildRESTFunction<typeof publicPosCheckout> & typeof publicPosCheckout
> = /*#__PURE__*/ createRESTModule(publicPosCheckout);
/**
 * This event is triggered when an order is deleted via a GDPR request.
 */
export const onOrderDeleted: BuildEventDefinition<typeof publicOnOrderDeleted> &
  typeof publicOnOrderDeleted = createEventModule(publicOnOrderDeleted);
/** */
export const onOrderUpdated: BuildEventDefinition<typeof publicOnOrderUpdated> &
  typeof publicOnOrderUpdated = createEventModule(publicOnOrderUpdated);
/** */
export const onOrderConfirmed: BuildEventDefinition<
  typeof publicOnOrderConfirmed
> &
  typeof publicOnOrderConfirmed = createEventModule(publicOnOrderConfirmed);
/** */
export const onOrderInitiated: BuildEventDefinition<
  typeof publicOnOrderInitiated
> &
  typeof publicOnOrderInitiated = createEventModule(publicOnOrderInitiated);
/** @deprecated */
export const onOrderReservationCreated: BuildEventDefinition<
  typeof publicOnOrderReservationCreated
> &
  typeof publicOnOrderReservationCreated = createEventModule(
  publicOnOrderReservationCreated
);
/** @deprecated */
export const onOrderReservationUpdated: BuildEventDefinition<
  typeof publicOnOrderReservationUpdated
> &
  typeof publicOnOrderReservationUpdated = createEventModule(
  publicOnOrderReservationUpdated
);

export {
  SubdivisionType,
  OrderStatus,
  ChannelType,
  TaxType,
  FeeName,
  FeeType,
  ScheduledActionEnumAction,
  Action,
  OrderType,
  OrderFieldset,
  OrderTag,
  WebhookIdentityType,
  ReservationStatus,
  State,
  TicketSaleStatus,
  Type,
  TicketDefinitionFieldset,
} from './events-v1-order-orders.universal.js';
export {
  Order,
  FormResponse,
  InputValue,
  FormattedAddress,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  StandardDetails,
  Money,
  TicketingTicket,
  CheckIn,
  GuestDetails,
  FormSubmission,
  TicketDetails,
  Invoice,
  Item,
  Discount,
  DiscountItem,
  DiscountItemDiscountOneOf,
  CouponDiscount,
  PaidPlanDiscount,
  PaidPlanDiscountDiscountOneOf,
  PercentDiscount,
  Tax,
  Fee,
  PaymentDetails,
  PaymentTransaction,
  GiftCardPaymentDetails,
  BalanceSummary,
  OrderDeleted,
  Ticket,
  OnlineConferencingLogin,
  ListOrdersRequest,
  ListOrdersResponse,
  FacetCounts,
  OrderFacets,
  OrderFacetCounts,
  Counts,
  GetOrderRequest,
  GetOrderResponse,
  CalendarLinks,
  UpdateOrderRequest,
  UpdateOrderResponse,
  OrderUpdated,
  BulkUpdateOrdersRequest,
  BulkUpdateOrdersResponse,
  ConfirmOrderRequest,
  ConfirmOrderResponse,
  GetSummaryRequest,
  GetSummaryResponse,
  TicketSales,
  GetInvoicePreviewRequest,
  RawHttpResponse,
  HeadersEntry,
  GetPaymentInfoRequest,
  GetPaymentInfoResponse,
  PaymentTransactionSummary,
  PaymentTransactionEvent,
  CaptureAuthorizedPaymentRequest,
  CaptureAuthorizedPaymentResponse,
  VoidAuthorizedPaymentRequest,
  VoidAuthorizedPaymentResponse,
  FindOrderByReservationIdRequest,
  FindOrderByReservationIdResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  OrderConfirmed,
  OrderPaid,
  ReservationCreated,
  TicketQuantity,
  ReservationCount,
  ReservationUpdated,
  GetCheckoutOptionsRequest,
  GetCheckoutOptionsResponse,
  ListAvailableTicketsRequest,
  ListAvailableTicketsResponse,
  ResponseMetaData,
  TicketDefinition,
  Dashboard,
  WixFeeConfig,
  TicketSalePeriod,
  TicketPricing,
  TicketPricingPriceOneOf,
  PricingOptions,
  PricingOption,
  QueryAvailableTicketsRequest,
  QueryAvailableTicketsResponse,
  CreateReservationRequest,
  TicketReservationQuantity,
  CreateReservationResponse,
  TicketReservation,
  CancelReservationRequest,
  CancelReservationResponse,
  GetInvoiceRequest,
  DiscountRequest,
  PaidPlanBenefit,
  GetInvoiceResponse,
  DiscountErrors,
  Error,
  GiftCardErrors,
  GiftCardErrorsError,
  CheckoutRequest,
  Buyer,
  Guest,
  CheckoutOptions,
  CheckoutResponse,
  OrderInitiated,
  UpdateCheckoutRequest,
  UpdateCheckoutResponse,
  OrderPageUrls,
  PosCheckoutRequest,
  PosCheckoutResponse,
  GetReservationRequest,
  GetReservationResponse,
  Reservation,
  ConfirmReservationRequest,
  ConfirmReservationResponse,
  ExpireReservationRequest,
  ExpireReservationResponse,
  QueryEventsWithPaidReservationsRequest,
  EventKey,
  QueryEventsWithPaidReservationsResponse,
  BaseEventMetadata,
  OrderDeletedEnvelope,
  OrderUpdatedEnvelope,
  OrderConfirmedEnvelope,
  OrderInitiatedEnvelope,
  OrderReservationCreatedEnvelope,
  OrderReservationUpdatedEnvelope,
  ListOrdersOptions,
  GetOrderIdentifiers,
  GetOrderOptions,
  UpdateOrderIdentifiers,
  UpdateOrderOptions,
  BulkUpdateOrdersOptions,
  ConfirmOrderOptions,
  GetSummaryOptions,
  CaptureAuthorizedPaymentOptions,
  VoidAuthorizedPaymentOptions,
  ListAvailableTicketsOptions,
  QueryAvailableTicketsOptions,
  CreateReservationOptions,
  GetInvoiceOptions,
  CheckoutOptionsForRequest,
  UpdateCheckoutOptions,
  PosCheckoutOptions,
} from './events-v1-order-orders.universal.js';
export {
  SubdivisionTypeWithLiterals,
  OrderStatusWithLiterals,
  ChannelTypeWithLiterals,
  TaxTypeWithLiterals,
  FeeNameWithLiterals,
  FeeTypeWithLiterals,
  ScheduledActionEnumActionWithLiterals,
  ActionWithLiterals,
  OrderTypeWithLiterals,
  OrderFieldsetWithLiterals,
  OrderTagWithLiterals,
  WebhookIdentityTypeWithLiterals,
  ReservationStatusWithLiterals,
  StateWithLiterals,
  TicketSaleStatusWithLiterals,
  TypeWithLiterals,
  TicketDefinitionFieldsetWithLiterals,
  UpdateOrderApplicationErrors,
  BulkUpdateOrdersApplicationErrors,
  ConfirmOrderApplicationErrors,
  CaptureAuthorizedPaymentApplicationErrors,
  VoidAuthorizedPaymentApplicationErrors,
} from './events-v1-order-orders.universal.js';
